<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">
      <!--    <v-card-title class="headline">-->
      <!--&lt;!&ndash;      <span class="mr-3">Пользователи</span>&ndash;&gt;-->
      <!--      <v-btn class="mr-3" color="green" dark to="/users/add">-->
      <!--        <v-icon>mdi-plus</v-icon>-->
      <!--        Добавить-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--          color="green"-->
      <!--          dark-->
      <!--          @click="showingDeleted = !showingDeleted"-->
      <!--      >-->
      <!--        <span v-if="!showingDeleted">Показать удаленных</span>-->
      <!--        <span v-else>Скрыть удаленных</span>-->
      <!--      </v-btn>-->
      <!--      <v-spacer></v-spacer>-->
      <!--      <v-text-field-->
      <!--          v-if="$store.getters.users"-->
      <!--          v-model="search"-->
      <!--          append-icon="mdi-magnify"-->
      <!--          label="Поиск"-->
      <!--          single-line-->
      <!--          hide-details-->
      <!--      ></v-text-field>-->
      <!--    </v-card-title>-->
      <v-card-title class="headline justify-space-between">
        <div>
          <v-btn class="mr-3" color="green" dark to="/users/add">
            <v-icon>mdi-plus</v-icon>
            Добавить
          </v-btn>
          <v-btn class="mr-3" color="green" dark @click="showingDeleted = !showingDeleted">
            <span v-if="!showingDeleted">Показать удаленных</span>
            <span v-else>Скрыть удаленных</span>
          </v-btn>
          <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div>
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
          ></v-text-field>
        </div>
      </v-card-title>
      <v-data-table
        class="mb-3 mx-3"
        :headers="headers"
        :items="users"
        :item-class="
          (item) =>
            item.isDeleted ? 'deletedUser clickable-row' : 'clickable-row'
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editUser"
        hide-default-footer
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteUserConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click.stop="restoreUser(item)" v-bind="attrs" v-on="on">
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          />
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление пользователя"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteUser($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingUserId: "",

      tableLoading: true,
      search: "",
      showingDeleted: false,
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "ФИО",
          align: "start",
          value: "fullName",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
          sortable: false,
        },
        {
          text: "Телефон",
          align: "start",
          value: "phone",
          sortable: false,
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Роль",
          align: "start",
          value: "roleName",
        },
        {
          text: "Изменил",
          align: "start",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    exportToFile(format) {
      const showingDeleted = this.showingDeleted;
      API.get(`users/reports?format=${format}&showingDeleted=${showingDeleted}`, { responseType: 'blob' })
        .then(response => {
          if (response.status === 200) {
            let contentType = '';
            let fileExtension = '';
            if (format === 'csv') {
              contentType = 'text/csv';
              fileExtension = '.csv';
            } else if (format === 'xlsx') {
              contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              fileExtension = '.xlsx';
            }
            const blob = new Blob([response.data], { type: contentType });
            const date = new Date();
            const currentDate = this.formatUpdateTime(date);
            const filename = `Отчет пользователи ${currentDate}${fileExtension}`.replace(/:/g, '.');
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            }
            console.log('Файл успешно загружен');
          } else {
            console.error('Ошибка загрузки файла:', response.statusText);
          }
        })
        .catch(error => {
          console.error('Ошибка загрузки файла:', error);
        });
    },
    editUser(user) {
      if (user.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Пользователь удален",
        });
      } else {
        this.$router.push("/users/" + user.id);
      }
    },
    deleteUserConfirm(user) {
      this.deletingUserId = user.id;
      this.$refs.confirmation.showDialog(
        user.id,
        `Вы действительно хотите удалить пользователя <span class="highlighted">${user.fullName}</span> ?`
      );
    },
    deleteUser(userId) {
      API.get(`users/${userId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateUsers");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    restoreUser(user) {
      API.get(`users/${user.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateUsers");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    users: function () {
      let shownUsers = this.$store.getters.users.filter(
        (user) => this.showingDeleted || !user.isDeleted
      );
      if (!this.search) return shownUsers;
      let search = this.search.toLocaleLowerCase();
      return shownUsers.filter((user) =>
        Object.keys(user).some(
          (key) =>
            typeof user[key] != "boolean" &&
            (user[key]
              .toString()
              .toLocaleLowerCase()
              .replace("ё", "е")
              .includes(search) ||
              user[key].toString().toLocaleLowerCase().includes(search))
        )
      );
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "users", disabled: true },
    ]);
  },
  created() {
    this.$store.dispatch("updateUsers").then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.deletedUser {
  background-color: #e5d4d4;
}
</style>
